import UsersManagementMultiStep from "components/adminStartup/UsersManagement";
import RBACSwitcher from "components/common/Auth/RBACSwitcher";
import ExcelAccountCreation from "components/adminStartup/UsersManagement/excel-account-creation";
const UsersManagement = () => {
  return (
    <RBACSwitcher
      admin={<UsersManagementMultiStep />}
      school={<div>UsersManagement Admin ecoles</div>}
    />
  );
};

export default UsersManagement;
